import React, { useLayoutEffect, useState } from 'react'

import { Breadcrumb, Card, Form, Icon, Typography } from 'antd'
import moment from 'moment'

import { RULES, validRule } from '../../../constants/Entitlements'
import { api, request } from '../../../util/handlerRequestUtil'
import FarmerPortalDashboardFilter from './Filters/FarmerPortalDashboardFilter'
import GeneralProductivity from './GeneralProductivity'
import PlantingTime from './PlantingTime'
import PopulationAndProductivity from './PopulationAndProductivity'
import ProductiveEnvironment from './ProductiveEnvironment'
import ProductivityComparison from './ProductivityComparison'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const FarmersPortalDashboard = function ({ history }) {
  const [formValues, setFormValues] = useState({})
  const updateDateTime = new Date()

  const [reportSelectedValues, setReportSelectedValues] = useState({})

  useLayoutEffect(() => {
    const hasAccess = validRule(RULES.DASHBOARD)
    if (!hasAccess) {
      return history.push('/customer/list')
    }
  }, [])

  const setFieldValueWithState = (field, value) => {
    setFormValues({
      ...formValues,
      [field]: value
    })
  }

  const setFieldValueWithFields = (fields) => {
    setFormValues({
      ...formValues,
      ...fields
    })
  }

  const clearFilter = () => {
    setFormValues({})
  }

  const handleClickFilter = async () => {
    if (Object.keys(formValues).length > 0) {
      const params = filterNormalize(formValues)

      const response = await request(api.dashboardFarmerPortal(params))
      setReportSelectedValues(response)
    }
  }

  const filterNormalize = (params) => {
    const {
      macroRegionFilter,
      microRegionFilter,
      stateFilter,
      countiesFilter,
      periods = [],
      materialsI2xFilter = [],
      materialsCheckFilter = []
    } = params

    return {
      macroRegion: macroRegionFilter,
      microRegion: microRegionFilter,
      state: stateFilter,
      counties: countiesFilter,
      periods,
      materialsI2x: materialsI2xFilter,
      materialsCheck: materialsCheckFilter
    }
  }

  return (
    <section>
      <Form layout="vertical">
        <div style={style.container}>
          <div style={style.breadcrumb}>
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => history.push('/')}>
                <Icon
                  type="home"
                  theme="filled"
                  style={{ fontSize: '16px', color: '#263447' }}
                  onClick={() => history.push('/')}
                />
              </Breadcrumb.Item>
              <Breadcrumb.Item>Dashboard Portal do Agricultor</Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ display: 'flex' }}>
              <Typography style={{ fontSize: 14, color: '#8591A1', margin: '0px 5px 0px 5px' }}>
                {'Dados atualizados em:'}
              </Typography>
              <Typography style={{ fontSize: 14, color: '#263447' }}>
                {moment(updateDateTime).format('DD/MM/YYYY')}
              </Typography>
              <Typography style={{ fontSize: 14, color: '#8591A1', margin: '0px 5px 0px 5px' }}>{'às'}</Typography>
              <Typography style={{ fontSize: 14, color: '#263447' }}>
                {moment(updateDateTime).format('HH:mm')}
              </Typography>
            </div>
          </div>
        </div>
        <Card className="ant-card gx-card ant-card-bordered">
          <FarmerPortalDashboardFilter
            values={formValues}
            setFieldValueWithState={setFieldValueWithState}
            handleClickFilter={handleClickFilter}
            handleClickClearFilter={clearFilter}
            setFieldValueWithFields={setFieldValueWithFields}
          />
        </Card>
      </Form>

      {reportSelectedValues !== {} ? (
        <>
          <GeneralProductivity values={reportSelectedValues.generalProductive} />

          <PlantingTime values={reportSelectedValues.plantingTime} />

          <ProductiveEnvironment values={reportSelectedValues.environmentProductive} />

          <PopulationAndProductivity values={reportSelectedValues.populationAndProductivity} />

          {/* Ocultado componente conforme tarefa https://app.clickup.com/t/2gfydgc */}
          {/*<ProductivityRanking values={reportSelectedValues.productivityRanking} />*/}

          <ProductivityComparison values={reportSelectedValues.productivityComparison} />
        </>
      ) : null}
    </section>
  )
}

const style = {
  container: {
    paddingBottom: '0.5rem'
  },
  breadcrumb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    alignItems: 'center'
  }
}

export default FarmersPortalDashboard
